/** 点击正式播放时通知所有封面预览释放连接 */
const pauseListeners = new Set();
const resumeListeners = new Set();

export function subscribePreviewPause(handler) {
    pauseListeners.add(handler);
    return () => pauseListeners.delete(handler);
}

export function subscribePreviewResume(handler) {
    resumeListeners.add(handler);
    return () => resumeListeners.delete(handler);
}

export function pauseAllPreviews() {
    pauseListeners.forEach((fn) => {
        try {
            fn();
        } catch {
            /* ignore */
        }
    });
}

/** 播放窗关闭后通知封面预览恢复显示 */
export function resumeAllPreviews() {
    resumeListeners.forEach((fn) => {
        try {
            fn();
        } catch {
            /* ignore */
        }
    });
}
